// extracted by mini-css-extract-plugin
export default {"bottomColumn":"index_bottomColumn_hVSIq","bottomColumnBox":"index_bottomColumnBox_wMtZ-","bottomColumnPic":"index_bottomColumnPic_clKxZ"};